import TextField from '@material-ui/core/TextField';
import React from 'react';
import { TaxInput } from '../../../utils/Cells';
import * as util from '../../../utils/Util';
import { useStyles } from '../styles/Styles';

export default function ErrorAwareTaxNumberField(props) {
    const classes = useStyles(props, "taxNumber")();

    const helperText = () => {
        if (props.errors && props.errors.has(props.name)) {
            return props.errors.get(props.name).huText;
        } else if (props.prevValue && util.trimSpaces(props.value) !== props.prevValue) {
            return props.prevValue;
        } else {
            return "";
        }
    }

    const isShrink = (v) => {
        if (v) {
            return true;
        } else {
            return false;
        }
    }

    const isError = () => {
        if (props.errors) {
            return props.errors.has(props.name);
        } else {
            return false;
        }
    }

    const { prevValue, ...rest } = props;
    return (
        <TextField
            fullWidth
            error={isError()}
            helperText={helperText()}
            variant="outlined"
            id={props.name}
            pattern="[0-9]*"
            autoComplete="off"
            className={classes.root}
            InputLabelProps={{ shrink: isShrink(props.value) }}
            FormHelperTextProps={{ className: "helper-text" }}
            InputProps={{ inputComponent: TaxInput, }}
            {...rest} />
    )

};